import React from 'react';
import { CheckCircle2Icon, ArrowRightIcon, ClockIcon, ShieldCheckIcon, FileTextIcon, UsersIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen10_PTPComplete({
  data,
  onNext,
  onBack
}: ScreenProps & {
  onGoToList?: () => void;
}) {
  return <div className="flex flex-col h-full" data-id="element-855">
      <div className="flex-1 flex flex-col items-center justify-center pb-8 -mx-2 px-2" data-id="element-856">
        {/* Celebration Icon */}
        <motion.div initial={{
        scale: 0,
        rotate: -20
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20,
        delay: 0.1
      }} className="mb-6" data-id="element-857">
          <div className="relative" data-id="element-858">
            <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center" data-id="element-859">
              <CheckCircle2Icon className="w-12 h-12 text-green-600" data-id="element-860" />
            </div>
            <motion.div initial={{
            opacity: 0,
            scale: 0
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.4,
            type: 'spring',
            stiffness: 400
          }} className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-yellow-400 flex items-center justify-center text-sm" data-id="element-861">
              🎉
            </motion.div>
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-862">
          Great Job!
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-gray-500 text-sm text-center mb-8 max-w-xs" data-id="element-863">
          Your Pre-Task Plan has been created successfully. The crew is safer
          because of your preparation.
        </motion.p>

        {/* PTP Summary Card */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="w-full bg-white border border-gray-200 rounded-xl p-4 mb-6" data-id="element-864">
          <div className="flex items-center gap-2 mb-3" data-id="element-865">
            <ShieldCheckIcon className="w-4 h-4 text-green-600" data-id="element-866" />
            <span className="text-xs font-bold text-green-600 uppercase tracking-wider" data-id="element-867">
              PTP Ready
            </span>
          </div>
          <p className="text-yellow-500 font-bold text-sm mb-3" data-id="element-868">
            {data.taskTitle || 'Pre-Task Plan'}
          </p>
          <div className="grid grid-cols-3 gap-3 text-center" data-id="element-869">
            <div className="bg-gray-50 rounded-lg py-2 px-1" data-id="element-870">
              <FileTextIcon className="w-3.5 h-3.5 text-gray-400 mx-auto mb-1" data-id="element-871" />
              <p className="text-gray-900 font-bold text-sm" data-id="element-872">
                {data.stepHazardData.length}
              </p>
              <p className="text-gray-400 text-[10px]" data-id="element-873">Steps</p>
            </div>
            <div className="bg-gray-50 rounded-lg py-2 px-1" data-id="element-874">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-gray-400 mx-auto mb-1" data-id="element-875" />
              <p className="text-gray-900 font-bold text-sm" data-id="element-876">
                {data.stepHazardData.reduce((acc, s) => acc + s.hazards.filter(h => h.relevant).length, 0)}
              </p>
              <p className="text-gray-400 text-[10px]" data-id="element-877">Hazards</p>
            </div>
            <div className="bg-gray-50 rounded-lg py-2 px-1" data-id="element-878">
              <UsersIcon className="w-3.5 h-3.5 text-gray-400 mx-auto mb-1" data-id="element-879" />
              <p className="text-gray-900 font-bold text-sm" data-id="element-880">{data.crewSize}</p>
              <p className="text-gray-400 text-[10px]" data-id="element-881">Crew</p>
            </div>
          </div>
        </motion.div>

        {/* Next Step Hint */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="bg-yellow-50 border border-yellow-200 rounded-xl px-4 py-3 w-full" data-id="element-882">
          <p className="text-yellow-700 text-xs leading-relaxed text-center" data-id="element-883">
            <span className="font-bold text-yellow-800" data-id="element-884">Next step:</span> Record
            the crew PTP meeting to verify understanding and capture additional
            safety information.
          </p>
        </motion.div>
      </div>

      <div className="sticky bottom-0 z-10 pt-3 pb-2 space-y-3 bg-gray-50" data-id="element-885">
        <PrimaryButton onClick={onNext} icon={<ArrowRightIcon className="w-5 h-5" data-id="element-887" />} data-id="element-886">
          Start PTP Meeting
        </PrimaryButton>
        <SecondaryButton onClick={onBack} icon={<ClockIcon className="w-5 h-5" data-id="element-889" />} data-id="element-888">
          Later
        </SecondaryButton>
      </div>
    </div>;
}